@use "../../../assets/styles/abstracts/variables" as v;
@use "../../../assets/styles/abstracts/mixins/typography" as t;

.formField {
  margin-bottom: 32px;
  position: relative;
}

.formFieldLabel {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.formFieldLabelTitle {
  color: v.$white-color;
  @include t.text(10px, 120%, "bold");
  letter-spacing: 0.6px;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.formFieldLabelForgotPassword {
  cursor: pointer;
  margin-bottom: 8px;
  color: v.$white-color;
  @include t.text(10px, 12px, "medium");
  letter-spacing: 0.6px;
  text-transform: uppercase;
}

.formFieldInputWrapper {
  position: relative;
}

.formFieldInputPasswordButton {
  position: absolute;
  top: 13px;
  right: 16px;
  cursor: pointer;
  top: 50%;
  transform: translateY(-50%);
}

.formFieldInputPasswordHidden {
  letter-spacing: 10px;
}

.formFieldInputPassword {
  padding-right: 39px !important;
}

.formFieldInput {
  height: 48px;
  width: 100%;
  padding: 13px 16px;
  border-radius: 8px;
  border: 1px solid v.$gray-border-color;
  background: v.$navy-color;
  color: v.$gray-light-color;
  @include t.text(14px, 22px, "normal");

  &:hover {
    border: 1px solid v.$green-dark-color;
  }

  &:focus-visible {
    border: 1px solid v.$green-color;
  }
}

.formFieldInputPassword {
  padding-right: 48px;
}

.formFieldInputInvalid {
  border: 1px solid v.$error-color;
}
